<div class="sessionContainer">
	<sim-session-card
		[session]="session"
		[event]="event"
		[sessionStartable]="sessionStartable"
		[showJoinStartActions]="showJoinStartActions"
	/>
</div>
